<template>
  <div class="ine-card inactive-plan">
    <p class="inactive-plan__name">
      {{ plan && plan.name ? plan.name : 'Legacy Plan' }}
    </p>
    <p class="inactive-plan__status">{{ activeLabel }}</p>
  </div>
</template>

<script>
import { formatSubDate } from '@/helpers'

export default {
  name: 'InactivePlan',
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  computed: {
    plan() {
      const {
        subscription: { plan },
      } = this
      return plan
    },
    activeLabel() {
      const {
        subscription: { expires_at, created_at },
      } = this
      return `Active: ${formatSubDate(created_at)} - ${formatSubDate(
        expires_at
      )}`
    },
  },
}
</script>

<style lang="scss">
.inactive-plan {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 15px;
  margin: 0 0 5px 0;
  &__name,
  &__status {
    padding: 0;
    margin: 0;
    color: var(--white);
    font-size: rem(14);
    line-height: 20px;
    flex: 0 0 50%;
  }
  &__status {
    font-size: 12px;
    line-height: 14px;
    color: var(--light-blue-gray);
  }
  &__name {
    width: 50%;
    @include mobile {
      width: 295px;
    }
  }
}
</style>
